import React from "react";

import { ConversationMessage } from "../../../../../model/integration/dto/meta/MetaConversationMessage";
import { integrationSliceSelectors } from "../../../../../redux/integration/integration.selector";
import { useAppSelector } from "../../../../../redux/store";
import { templateValuesFrom } from "../utils/templateVariables";
import { WATemplateContent } from "./WATemplateContent";

type Props = {
  message: ConversationMessage;
};

/** A sent template, drawn as the customer received it.
 *
 * The parts are read from the template the inbox last listed rather than from
 * the stored message, because a media header's link is signed and expires - a
 * month-old message would otherwise show a broken image.
 */
export const WAMessageTemplate: React.FC<Props> = ({ message }) => {
  const templates = useAppSelector(
    integrationSliceSelectors.selectWhatsAppMetaTemplates,
  );

  const stored = message.template;
  const live = templates?.find((template) => template.id === stored?.id);

  const template = live || stored;

  return (
    <WATemplateContent
      components={template?.components}
      values={templateValuesFrom(template, message.templateParameters)}
    />
  );
};
